function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.41 8L12 12.58 16.59 8 18 9.41l-6 6-6-6z"
});
const SvgIconDevIcKeyboardArrowDown = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDevIcKeyboardArrowDown, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dev-ic-keyboard-arrow-down.0f7c285a.svg";
export { ForwardRef as ReactComponent };